/**
 * Волна D (docs/MIGRATION_ROUTER.md §5). Было: <PrivateRoute path='/catalog/:id'>
 * (не-exact — матчил и /catalog/<id>/r/page/2, /r/sort/... и т.п., §3.2).
 * Сплат матчит и «голый» /catalog/<id>/r.
 */
import { createFileRoute } from '@tanstack/react-router';
import { catalogNotFoundLoader } from '@routes/Catalog/catalogNotFoundLoader';
import CacheDataRoute from '../../../../CacheDataRoute';
import Catalog from '@routes/Catalog/component';

export const Route = createFileRoute('/catalog/$id/r/$')({
  // Честный 404 несуществующей рубрики/группы (CONTENT_NOT_FOUND)
  loader: catalogNotFoundLoader,
  component: () => <CacheDataRoute component={Catalog} path='/catalog/:id' />
});
